module.exports = __webpack_public_path__ + "static/media/hands-holding-heart.b7a28e2c.svg";